import pagesContractorCoreInstanceEn from './instance/default';
import pagesContractorCoreOperationPackagesEn from './operation-packages/default';

export default {
  instance: pagesContractorCoreInstanceEn,
  operationPackages: pagesContractorCoreOperationPackagesEn,
};
